import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { OnboardingService } from '../services/onboarding.service';
import { SubscriptionStore } from '../stores/subscription-store';
import { postLoginOnboardingRedirect } from '../components/onboarding/onboarding-phase.util';

/**
 * Backstop for incomplete onboarding — independent of whichever auth entry
 * point (fresh login, OAuth, login-as, or an already-active session) brought
 * the user here, this re-checks on every activation of a guarded route so
 * there's no path that quietly skips onboarding.
 */
export const onboardingGuard: CanActivateFn = async () => {
  const authSvc = inject(AuthenticationService);

  if (!authSvc.isUserLoggedIn()) {
    return true; // authenticationGuard handles the redirect to /login
  }

  const onboardingSvc = inject(OnboardingService);
  const subscriptionStore = inject(SubscriptionStore);
  const router = inject(Router);

  try {
    const onboarding = await lastValueFrom(onboardingSvc.getOnboarding());
    const redirect = postLoginOnboardingRedirect(onboarding, subscriptionStore.isSubscribed());
    if (redirect) {
      return router.parseUrl(redirect);
    }
  } catch (err) {
    // best-effort — don't block access to the app on a failed check
    console.error('Onboarding status check failed:', err);
  }

  return true;
};
